import merge from 'lodash.merge';
import request from 'superagent';
import uuid from 'uuid/v4';
import isMobile from './isMobile';
import defaults from './configDefaults';

import { USER_LOCAL_STORAGE_KEY, CONVERSATION_ID_LOCAL_STORAGE_KEY } from './constants';

const config = window.AmbitConfig;
config.isMobile = isMobile();

if (
  config.localConfigOnly &&
  config.theme &&
  config.theme.accentColor &&
  !config.theme.botCardButtonOutlineColor
) {
  config.theme.botCardButtonOutlineColor = config.theme.accentColor;
}

export const getLocalStorageUser = localDirectLine => {
  const user = window.localStorage.getItem(USER_LOCAL_STORAGE_KEY);

  if (!user) {
    if (!localDirectLine) {
      const user = {
        name: 'anon',
        id: uuid()
      };
      window.localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user));
      return user;
    }
    return null;
  }

  return JSON.parse(user);
};

const mergedConfigPromise = new Promise((resolve, reject) => {
  if (!config.botBaseUrl || config.localConfigOnly) {
    if (config.theme && config.theme.accentColor && !config.theme.botCardButtonOutlineColor) {
      config.theme.botCardButtonOutlineColor = config.theme.accentColor;
    }

    return resolve(merge({}, defaults, config));
  }

  return request
    .get(`${config.botBaseUrl}/public/settings/webchat`)
    .then(res => {
      const serverSettings = res.body;

      // Local configuration is highest priority, followed by Synapse config, then the defaults.
      resolve(merge({}, defaults, serverSettings, config));
    })
    .catch(err => {
      console.log('Ambit: Unable to communicate with the bot, giving up.', err);
      reject(err);
    });
});

const configPromise = new Promise(resolve => {
  mergedConfigPromise.then(mergedConfig => {
    // If there's no user provided in the configuration, either get it from local storage or
    // generate our own
    if (!mergedConfig.user) {
      mergedConfig.user = getLocalStorageUser(mergedConfig.localDirectLine);
    }

    // Setup directline
    if (!mergedConfig.directLine) {
      mergedConfig.directLine = {
        secret: mergedConfig.secret || mergedConfig.botId
      };

      if (mergedConfig.localDirectLine) {
        mergedConfig.directLine.domain = `${mergedConfig.botBaseUrl}/v3/directline`;
      }
    }

    // If there is no conversationId and we are configured to remember the conversation
    if (
      !mergedConfig.directLine.conversationId &&
      mergedConfig.rememberConversation &&
      // Previous to the rememberConversation option being available, a workaround was to remove
      // the botBaseUrl parameter. We want to keep the same behaviour for people using
      // that workaround.
      mergedConfig.botBaseUrl
    ) {
      mergedConfig.directLine.conversationId = window.localStorage.getItem(
        CONVERSATION_ID_LOCAL_STORAGE_KEY
      );
    }

    // If we're configured to be inline, we don't want to show the launcher
    if (mergedConfig.inline) {
      mergedConfig.showLauncher = false;
    }

    resolve(mergedConfig);
  });
});

export default configPromise;



// WEBPACK FOOTER //
// ./src/initialiser/config.js